/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CollectionItemToggle_plant$ref: FragmentReference;
declare export opaque type CollectionItemToggle_plant$fragmentType: CollectionItemToggle_plant$ref;
export type CollectionItemToggle_plant = {|
  +id: string,
  +title: string,
  +myCollectionItem: ?{|
    +id: string
  |},
  +$refType: CollectionItemToggle_plant$ref,
|};
export type CollectionItemToggle_plant$data = CollectionItemToggle_plant;
export type CollectionItemToggle_plant$key = {
  +$data?: CollectionItemToggle_plant$data,
  +$fragmentRefs: CollectionItemToggle_plant$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "CollectionItemToggle_plant",
  "type": "LifeNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "myCollectionItem",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionItem",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '29a97be15fcf4c04ddfd6068877ef9c8';
module.exports = node;
